const getters = {
  cachedViews: (state) => state.cachedView.cachedViews,
  area: (state) => state.cachedView.area,
  paper: (state) => state.cachedView.paper,
  notification: (state) => state.cachedView.notification,
};

export default getters;
